export enum ModalName {
    SubProductModal = "SubProductModal",
    FileUploadModal = "FileUploadModal",
    PromotionTagUploadModal = "PromotionTagUploadModal",
    NameEditModal = "NameEditModal",
}

export enum ModalMode {
    Add = "Add",
    Edit = "Edit",
}

interface IndexerParams {
    subProductId: string;
    propertyAccessor: string;
}

interface FormParams {
    mode: ModalMode;
    idx?: number;
}

interface ModalWithParams<T extends Record<string, any>> {
    params: T;
}

type FormTypeModal = ModalWithParams<FormParams>;
type PropertyTypeModal = ModalWithParams<IndexerParams>;
export interface ISubProductModal extends FormTypeModal {
    id: ModalName.SubProductModal;
}

export interface IFileUploadModal extends PropertyTypeModal {
    id: ModalName.FileUploadModal;
    params: PropertyTypeModal["params"] & {
        isImageFile?: boolean;
    };
}

export interface IPromotionTagUploadModal extends PropertyTypeModal {
    id: ModalName.PromotionTagUploadModal;
}

export interface INameEditModal {
    id: ModalName.NameEditModal;
}

export type Modal =
    | ISubProductModal
    | IFileUploadModal
    | IPromotionTagUploadModal
    | INameEditModal;
